<!-- footer start -->
<footer class="mt-5">
  <div class="container social-media-footer-links">
    <div class="d-flex d-md-none p-3 bg-white shadow-sm rounded-10 row mx-0 upgrade-popup-mobile-view" *ngIf="popupHide && header">
      <div class="col-auto px-0 align-self-center">
        <div class="px-2 rounded-pill bg-primary wh-30px text-center">
          <img
            src="../assets/img/kingpin-logo.webp"
            alt="right"
            class="img-fluid"
            width="15"
            height="15"
            loading="lazy"
          />
        </div>
      </div>
      <div class="col px-0 align-self-center text-center">
        <span class="fw-bolder"> #1 App for Sports Bettors </span>
      </div>
      <div class="col-auto px-0 align-self-center">
        <button
          type="button"
          class="btn-close"
          aria-label="close-button"
          title="close"
          (click)="hidePopup()"
        ></button>
      </div>
      <div class="col-12 mt-3 text-center px-0">
        <a
          href="https://kingpin.pro/downloadapp"
          class="btn btn-subscription-green w-100 py-2 text-f14 fw-bolder"
        >DOWNLOAD THE APP</a>
      </div>
    </div>

    <div class="row">
      <div class="col-4 text-center bg-blue-gradient py-2">
        <a
          href="https://www.instagram.com/kingpin_pro"
          target="_blank"
          aria-label="Kingpin Instagram"
          class="text-white d-flex justify-content-center text-decoration-none"
        ><i class="fab fa-instagram me-md-2 h3 mb-0"></i>
          <span class="align-self-center small d-none d-md-block">Instagram</span></a>
      </div>
      <div class="col-4 text-center bg-blue-gradient py-2">
        <a
          href="https://twitter.com/kingpin_pro"
          target="_blank"
          class="text-white d-flex justify-content-center text-decoration-none"
          aria-label="Kingpin Twitter"
        ><i class="fab fa-twitter me-md-2 h3 mb-0"></i>
          <span class="align-self-center small d-none d-md-block">Twitter</span></a>
      </div>
      <div class="col-4 text-center bg-blue-gradient py-2">
        <a
          routerLink="/subscription"
          aria-label="Become a kingpin member"
          class="text-white d-flex justify-content-center text-decoration-none"
        ><i class="fa fa-crown me-md-2 h4 mb-0"></i>
          <span class="align-self-center small d-none d-md-block">Upgrade Now</span></a>
      </div>
    </div>
  </div>

  <div class="main-footer py-4">
    <div class="container text-center">
      <div class="mb-4">
        <img
          src="../assets/img/kingpin-logo-white.png"
          alt="footer logo"
          class="img-fluid"
          width="92"
          height="86"
          loading="lazy"
        />
      </div>
      <div class="mb-4">
        <ul class="list-inline">
          <li class="list-inline-item me-4" *ngIf="platform != 'iOS'">
            <a [href]="playstore" target="_blank">
              <img
                webpimage
                src="../assets/img/play-store.png"
                alt="play-store"
                class="img-fluid"
                width="130"
                height="43"
                loading="lazy"
              /></a>
          </li>
          <li class="list-inline-item">
            <a [href]="appstore" target="_blank" *ngIf="platform != 'Android'">
              <img
                webpimage
                src="../assets/img/apple-store.png"
                alt="apple-store"
                class="img-fluid"
                width="130"
                height="43"
                loading="lazy"
              /></a>
          </li>
        </ul>
      </div>

      <div class="mb-4">
        <ul class="list-inline">
          <li class="list-inline-item me-4">
            <a
              href="javascript:void(0)"
              routerLink="/privacy-policy"
              class="text-white text-decoration-none"
            >Privacy Policy</a>
          </li>
          <li class="list-inline-item me-4">
            <a
              href="javascript:void(0)"
              routerLink="/terms-of-service"
              class="text-white text-decoration-none"
            >Terms of Service</a>
          </li>
          <li class="list-inline-item me-4">
            <a
              href="javascript:void(0)"
              routerLink="/contact-us"
              class="text-white text-decoration-none"
            >Contact us</a>
          </li>
          <li class="list-inline-item me-4">
            <a
              href="javascript:void(0)"
              routerLink="/career"
              class="text-white text-decoration-none"
            >Careers</a>
          </li>
          <li class="list-inline-item">
            <a
              href="https://kingpin.pro/sitemap-new.xml"
              target="_blank"
              class="text-white text-decoration-none"
            >Sitemap</a>
          </li>
          <li class="list-inline-item">
            <a
              href="https://kingpin.pro/sitemap-articles.xml"
              target="_blank"
              class="text-white text-decoration-none"
            >Articles Sitemap</a>
          </li>
          <li class="list-inline-item">
            <a
              href="https://kingpin.pro/sitemap-news.xml"
              target="_blank"
              class="text-white text-decoration-none"
            >News Sitemap</a>
          </li>
        </ul>
      </div>

      <div class="mb-4">
        <ul class="list-inline">
          <li class="list-inline-item me-4">
            <a
              href="javascript:void(0)"
              routerLink="/nba/expert-picks"
              class="text-white text-decoration-none"
            >NBA Expert Picks & Predictions</a>
          </li>
          <li class="list-inline-item me-4">
            <a
              href="javascript:void(0)"
              routerLink="/nfl/expert-picks"
              class="text-white text-decoration-none"
            >NFL Expert Picks & Predictions</a>
          </li>
          <li class="list-inline-item me-4">
            <a
              href="javascript:void(0)"
              routerLink="/nhl/expert-picks"
              class="text-white text-decoration-none"
            >NHL Expert Picks & Predictions</a>
          </li>
          <li class="list-inline-item me-4">
            <a
              href="javascript:void(0)"
              routerLink="/ncaaf/expert-picks"
              class="text-white text-decoration-none"
            >College Football Expert Picks & Predictions</a>
          </li>     
          <li class="list-inline-item me-4">
            <a
              href="javascript:void(0)"
              routerLink="/ncaab/expert-picks"
              class="text-white text-decoration-none"
            >NCAAB Expert Picks & Predictions</a>
          </li>              
          <li class="list-inline-item me-4">
            <a
              href="javascript:void(0)"
              routerLink="/mlb/expert-picks"
              class="text-white text-decoration-none"
            >MLB Picks & Predictions</a>
          </li>         
        </ul>
      </div>

      <div class="pt-4 border-top">
        <span class="text-white text-f10">© Copyright Kingpin.pro 2018 | All Rights Reserved | Must be 18 or older. All gambling is simulated. Gamble responsibly.</span>
      </div>
    </div>
  </div>

</footer>
<!-- footer end -->

<div
  class="modal fade"
  id="appusemodal"
  tabindex="-1"
  aria-labelledby="appusemodalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body text-center download-popup">
        <p>
          This feature is only available on the
          <ng-container *ngIf="platform != 'iOS'">
            Google Play Store
          </ng-container>
          <ng-container *ngIf="platform != 'iOS' && platform != 'Android'">
            &
          </ng-container>
          <ng-container *ngIf="platform != 'Android'">
            Apple App Store
          </ng-container>
        </p>
        <div class="applink d-flex justify-content-center">
          <div class="android me-2" style="max-width: 200px" *ngIf="platform != 'iOS'">
            <a href="/ios" target="_blank">
              <img
                webpimage
                alt="play store"
                src="../assets/img/play-store.png"
                class="img-fluid"
                loading="lazy"
              />
            </a>
          </div>
          <div class="apple" style="max-width: 200px" *ngIf="platform != 'Android'">
            <a href="/ios" target="_blank">
              <img
                webpimage
                alt="app store"
                src="../assets/img/apple-store.png"
                class="img-fluid"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
